import React, { Component } from "react";
import { connect } from "react-redux";
import EmptyCart from "./EmptyCart";
import CartItemFeatured from "./CartItemFeatured";
import taxiImage from "../../Images/jesse-bowser-6060-unsplash.jpg";
import greyTaxiImage from "../../Images/jesse-bowser-grey-6060-unsplash.jpg";
import { airportPickUp } from "../Store/Actions/EuropeActions";
import { americaAirportPickUp } from "../Store/Actions/AmericaActions";
import { asiaAirportPickUp } from "../Store/Actions/AsiaActions";

class AirportPickUp extends Component {
  render() {
    const europeInCart = this.props.europeData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    const asiaInCart = this.props.asiaData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    const americaInCart = this.props.americaData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    function checkNull(arr) {
      return arr !== "fail";
    }
    const itemsInCart = europeInCart.concat(asiaInCart, americaInCart);
    const dispayItems = itemsInCart.map((item, i, arr) =>
      arr.length - 1 === i ? (
        <CartItemFeatured
          key={item.id}
          item={item}
          standardOptionValue={item.standardPickUp}
          Option1Value={item.pickUp}
          Option1Description="Pick up from airport"
          choosenValue={item.choosenPickUp}
          option1={taxiImage}
          standardImg={greyTaxiImage}
          handleChange={
            item.continent === "europe"
              ? this.props.airportPickUp
              : item.continent === "asia"
              ? this.props.asiaAirportPickUp
              : this.props.americaAirportPickUp
          }
          line = {false}
        />
      ) : (
        <CartItemFeatured
          key={item.id}
          item={item}
          standardOptionValue={item.standardPickUp}
          Option1Value={item.pickUp}
          Option1Description="Pick up from airport"
          choosenValue={item.choosenPickUp}
          option1={taxiImage}
          standardImg={greyTaxiImage}
          handleChange={
            item.continent === "europe"
              ? this.props.airportPickUp
              : item.continent === "asia"
              ? this.props.asiaAirportPickUp
              : this.props.americaAirportPickUp
          }
          line={true}
        />
      )
    );

   
    console.log(itemsInCart);
    return (
      <React.Fragment>
        <div className="airport-pick-up-parallax parallax d-flex justify-content-center align-items-center">
          <h1 className="main-photo-text">Airport pick-up</h1>
        </div>
        <div className="container mt-4">
          <div className="card">
            <div className="card-body">
              {itemsInCart.length === 0 ? (
                <EmptyCart />
              ) : (
                <h2 className="text-center card-title">Items in cart</h2>
              )}
              {dispayItems}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  europeData: state.europe,
  asiaData: state.asia,
  americaData: state.america
});

const mapDispatchToProps = dispatch => {
  return {
    airportPickUp: (id, data) => {
      dispatch(airportPickUp(id, data));
    },
    americaAirportPickUp: (id, data) => {
      dispatch(americaAirportPickUp(id, data));
    },

    asiaAirportPickUp: (id, data) => {
      dispatch(asiaAirportPickUp(id, data));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AirportPickUp);
